export default {
  info: console.info,
  error: console.error,
}
